module.exports = __webpack_public_path__ + "static/media/2.11_preview.e7134401.png";